import { AddErrorProps } from './ErrorAlertContext';
import { getApiErrorMessage } from './getApiErrorMessage';

type SwrCommonOnErrorHandlerProps = {
  err: any;
  addError: (props: AddErrorProps) => void;
};

function swrCommonOnErrorHandler({ err, addError }: SwrCommonOnErrorHandlerProps) {
  addError({
    message: getApiErrorMessage(err),
    errorObject: err,
    key: Date.now().toString(),
  });
}

export { swrCommonOnErrorHandler };
